import { createContext, useContext, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ResetPassword from "@/pages/ResetPassword";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

function Guard({ children, needAuth }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-400 font-mono text-xs" data-testid="auth-loading">Verifica sessione…</div>;
  if (needAuth && !user) return <Navigate to="/login" replace />;
  if (!needAuth && user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await api.post("/auth/refresh");
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        setUser(false);
      }
    });
  }, []);

  return (
    <AuthCtx.Provider value={{ user, setUser }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Guard><Login /></Guard>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Guard needAuth><Dashboard /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthCtx.Provider>
  );
}

export default App;
